export default __webpack_public_path__ + "static/media/cake-5.99252234.jpg";